import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const PHONE = process.env.REACT_APP_WHATSAPP_NUMBER;
const MESSAGE = encodeURIComponent(
  "Hi Dr. Mishra, I found your website and would like to enquire about a consultation."
);
const WA_URL = `https://wa.me/${PHONE}?text=${MESSAGE}`;

const WhatsAppIcon = ({ size = 26 }) => (
  <svg viewBox="0 0 32 32" width={size} height={size} fill="currentColor" aria-hidden="true">
    <path d="M16.004 3.2c-7.06 0-12.8 5.74-12.8 12.8 0 2.257.59 4.463 1.71 6.408L3.2 28.8l6.57-1.68a12.74 12.74 0 0 0 6.234 1.6h.005c7.06 0 12.8-5.74 12.8-12.8s-5.74-12.72-12.805-12.72Zm0 23.04h-.004a10.6 10.6 0 0 1-5.4-1.48l-.387-.23-4.003 1.024 1.07-3.9-.253-.4a10.55 10.55 0 0 1-1.62-5.66c0-5.86 4.77-10.63 10.64-10.63 2.84 0 5.51 1.108 7.52 3.118a10.56 10.56 0 0 1 3.11 7.52c0 5.86-4.77 10.63-10.68 10.63Zm5.83-7.96c-.32-.16-1.89-.93-2.18-1.04-.29-.107-.5-.16-.712.16-.213.32-.82 1.04-1.005 1.253-.185.213-.37.24-.69.08-.32-.16-1.35-.498-2.57-1.586-.95-.847-1.59-1.893-1.777-2.213-.185-.32-.02-.493.14-.653.144-.143.32-.373.48-.56.16-.187.213-.32.32-.533.107-.213.053-.4-.027-.56-.08-.16-.712-1.72-.976-2.353-.257-.617-.518-.533-.712-.543l-.606-.01c-.213 0-.56.08-.853.4-.293.32-1.12 1.093-1.12 2.667 0 1.573 1.147 3.093 1.307 3.307.16.213 2.257 3.447 5.467 4.833.764.33 1.36.527 1.824.674.766.244 1.464.21 2.016.127.615-.092 1.89-.773 2.156-1.52.267-.746.267-1.386.187-1.52-.08-.133-.293-.213-.613-.373Z" />
  </svg>
);

export const WhatsAppButton = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 500);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.a
          data-testid="whatsapp-fab"
          href={WA_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Chat on WhatsApp"
          initial={{ opacity: 0, scale: 0.6, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.6, y: 20 }}
          whileHover={{ scale: 1.06 }}
          whileTap={{ scale: 0.94 }}
          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          className="group fixed bottom-6 right-6 z-[60] flex items-center gap-3"
        >
          <span className="hidden md:block bg-emerald text-ivory text-sm tracking-wide px-4 py-2 opacity-0 group-hover:opacity-100 translate-x-2 group-hover:translate-x-0 transition-all duration-300 whitespace-nowrap shadow-[0_10px_30px_rgba(11,43,33,0.25)]">
            Chat on WhatsApp
          </span>
          <span className="relative flex items-center justify-center h-14 w-14 rounded-full bg-emerald text-ivory shadow-[0_12px_30px_rgba(11,43,33,0.35)] ring-1 ring-champagne/40">
            <span className="absolute inset-0 rounded-full bg-champagne/30 animate-ping opacity-40" />
            <WhatsAppIcon size={26} />
          </span>
        </motion.a>
      )}
    </AnimatePresence>
  );
};

export default WhatsAppButton;
